if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector('pickup-availability');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        console.log('[Lieferzeit] connectedCallback() für section', this.sectionId, 'productId', this.productId);

        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.currentVariant = this.getSelectedVariant(this);
        console.log('[Lieferzeit] connectedCallback(): currentVariant nach getSelectedVariant =', this.currentVariant);

        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }

        // Lieferzeit direkt beim Laden setzen
        this.updateLieferzeit(this.currentVariant);
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        console.log('[Lieferzeit] handleOptionValueChange(): selectedOptionValues =', selectedOptionValues);

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        console.log(
          '[Lieferzeit] handleOptionValueChange(): productUrl =',
          productUrl,
          'shouldSwapProduct =',
          shouldSwapProduct,
          'shouldFetchFullPage =',
          shouldFetchFullPage,
          'viewMode =',
          viewMode
        );

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode),
        });
      }

      get productForm() {
        return this.querySelector('form[is="product-form"');
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.resetFormState();
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          console.log('[Lieferzeit] handleSwapProduct(): viewMode =', viewMode, 'updateFullPage =', updateFullPage);

          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const productInfoNode = html.querySelector(selector);
          console.log(
            '[Lieferzeit] handleSwapProduct(): selector =',
            selector,
            'node gefunden?',
            !!productInfoNode
          );

          const variant = this.getSelectedVariant(productInfoNode);

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          console.log('[Lieferzeit] handleSwapProduct(): neue Variante =', variant);

          this.currentVariant = variant;
          this.updateLieferzeit(variant);
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          console.log('[Lieferzeit] handleUpdateProductInfo(): viewMode =', viewMode);

          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }

          const variant = this.getSelectedVariant(html);
          console.log('[Lieferzeit] handleUpdateProductInfo(): Variante aus HTML =', variant);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            console.warn(
              '[Lieferzeit] handleUpdateProductInfo(): keine Variante gefunden, setUnavailable + Default Lieferzeit'
            );
            this.setUnavailable();
            this.updateLieferzeit(null);
            return;
          }

          this.currentVariant = variant;
          this.updateMedia(variant);
          this.updateLieferzeit(variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Barcode', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Badges', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('PricePerItem', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Volume');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          this.querySelector(`#QuantityRules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#VolumeNote-${this.dataset.section}`)?.classList.remove('hidden');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: this.currentVariant,
              },
            })
          );

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        const finalUrl = `${url}?${params.join('&')}`;
        console.log('[Lieferzeit] buildRequestUrlWithParams():', finalUrl);
        return finalUrl;
      }

      getSelectedVariant(productInfoNode) {
        if (!productInfoNode) {
          console.warn('[Lieferzeit] getSelectedVariant(): productInfoNode ist null');
          return null;
        }

        const scriptEl = productInfoNode.querySelector('variant-selects [data-selected-variant]');
        console.log('[Lieferzeit] getSelectedVariant(): scriptEl gefunden?', !!scriptEl, scriptEl);

        if (!scriptEl) {
          console.warn('[Lieferzeit] Kein [data-selected-variant] gefunden');
          return null;
        }

        const rawJson = scriptEl.innerHTML.trim();
        console.log('[Lieferzeit] getSelectedVariant(): JSON-String:', rawJson);

        if (!rawJson) {
          console.warn('[Lieferzeit] getSelectedVariant(): leerer JSON-String');
          return null;
        }

        try {
          const variant = JSON.parse(rawJson);
          console.log('[Lieferzeit] getSelectedVariant(): geparste Variante:', variant);
          return variant;
        } catch (e) {
          console.error('[Lieferzeit] Fehler beim Parsen von selected-variant JSON:', e);
          return null;
        }
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        console.log('[Lieferzeit] renderProductInfo(): requestUrl =', requestUrl);

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        const newUrl = `${url}${variantId ? `?variant=${variantId}` : ''}`;
        console.log('[Lieferzeit] updateURL():', newUrl);
        window.history.replaceState({}, '', newUrl);
      }

      updateVariantInputs(variantId) {
        console.log('[Lieferzeit] updateVariantInputs(): variantId =', variantId);

        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return;

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true;
          }
          return false;
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        const shareUrl = `${window.shopUrl}${this.dataset.url}?variant=${variantId}`;
        console.log('[Lieferzeit] updateShareUrl():', shareUrl);
        shareButton.updateUrl(shareUrl);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = FoxTheme.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }

      // ---------------- Lieferzeit: Helpers & Logik ----------------

      get variantDeliveryData() {
        if (this._variantDeliveryData) {
          return this._variantDeliveryData;
        }

        const script = this.querySelector('[data-variant-delivery]');
        console.log('[Lieferzeit] variantDeliveryData(): Script gefunden?', !!script, script);

        if (!script) {
          console.warn('[Lieferzeit] Kein <script data-variant-delivery> gefunden');
          this._variantDeliveryData = {};
          return this._variantDeliveryData;
        }

        const rawJson = script.textContent.trim();
        console.log('[Lieferzeit] variantDeliveryData(): JSON-String:', rawJson);

        if (!rawJson) {
          console.warn('[Lieferzeit] variantDeliveryData(): leerer JSON-String');
          this._variantDeliveryData = {};
          return this._variantDeliveryData;
        }

        try {
          const map = JSON.parse(rawJson);
          console.log('[Lieferzeit] variantDeliveryData(): geparste Map:', map);
          this._variantDeliveryData = map;
        } catch (e) {
          console.error('[Lieferzeit] Fehler beim Parsen von data-variant-delivery JSON:', e);
          this._variantDeliveryData = {};
        }

        return this._variantDeliveryData;
      }

      getDeliveryInfoForVariant(variant) {
        if (!variant) {
          console.warn('[Lieferzeit] getDeliveryInfoForVariant(): variant ist null');
          return {};
        }
        const map = this.variantDeliveryData;
        const entry = map[String(variant.id)] || {};
        console.log('[Lieferzeit] getDeliveryInfoForVariant(): variant.id =', variant.id, 'Entry =', entry);

        return {
          deliverystock: entry.deliverystock || '',
          deliveryoversold: entry.deliveryoversold || '',
          inventory_quantity:
            typeof entry.inventory_quantity === 'number'
              ? entry.inventory_quantity
              : Number(entry.inventory_quantity || 0),
          inventory_policy: entry.inventory_policy || null,
          inventory_management: entry.inventory_management || null,
          available: typeof entry.available === 'boolean' ? entry.available : !!entry.available,
        };
      }

     updateLieferzeit(variant) {
  const deliveryElement = this.querySelector('[data-delivery-time]');

  if (!deliveryElement) return;

  // Einfache Produkte weiterhin von Liquid behandeln lassen
  const hasVariantDeliveryScript = !!this.querySelector('[data-variant-delivery]');
  if (!hasVariantDeliveryScript) {
    return;
  }

  let text = 'Lieferzeit: ca. 2–4 Wochen';

  if (variant) {
    const info = this.getDeliveryInfoForVariant(variant);

    const quantity = Number(info.inventory_quantity ?? 0);

    const deliveryStock = (info.deliverystock || '').trim();
    const deliveryOversold = (info.deliveryoversold || '').trim();

    if (quantity > 0) {
      text = deliveryStock || 'Lieferzeit: ca. 4 Werktage';
    } else {
      text = deliveryOversold || 'Lieferzeit: ca. 2–4 Wochen';
    }

    console.log('[Lieferzeit]', {
      variantId: variant.id,
      quantity,
      text
    });
  }

  deliveryElement.textContent = text;
  deliveryElement.classList.remove('hidden');
}

    }
  );
}

if (!customElements.get('product-promotion-alert')) {
  customElements.define(
    'product-promotion-alert',
    class ProductPromotionAlert extends HTMLElement {
      constructor() {
        super();

        this.abortController = new AbortController();
        this.buttonEl = this.querySelector('button');
        this.buttonEl.addEventListener('click', this.onClick.bind(this), {
          signal: this.abortController.signal,
        });
      }

      onClick(evt) {
        evt.preventDefault();

        this.closest('.product__block').classList.add('hidden');
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}
